<template>
  <div>
    <div v-if="displayTable" class="d-flex">
      <b-button class="mb-2 mr-2" variant="primary" @click="addUser">
        Ajouter utilisateur
      </b-button>
      <div class="user-fixed-search">
        <b-input-group class="input-group-merge w-100 round">
          <b-input-group-prepend is-text>
            <feather-icon icon="SearchIcon" class="text-muted" />
          </b-input-group-prepend>
          <b-form-input v-model="searchQuery" placeholder="Rechercher..." />
        </b-input-group>
      </div>
    </div>
    <div v-else>
      <b-button class="mb-2" variant="primary" @click="backToTable">
        Retour
      </b-button>
    </div>
    <b-card no-body class="mb-0">
      <div v-if="displayTable">
        <b-table :fields="fields" :responsive="true" :items="filteredUsers" :per-page="perPage"
                 :current-page="currentPage">
          <template v-if="filteredUsers.length === 0" #top-row>
            <p class="d-flex justify-content-center">
              Aucun résultat trouvé
            </p>
          </template>
          <template #cell(status)="data">
            <div class="form-check form-switch">
              <div>
                <span v-if="data.value === true">Actif</span>
                <span v-else>Inactif</span>
              </div>
            </div>
          </template>
          <template #cell(message)="data">
            <div class="form-check form-switch">
              <div>
                <span v-if="data.value === true">
                  Oui
                  <feather-icon icon="CheckIcon" class="isBackup" />
                </span>
                <span v-else>Non</span>
              </div>
            </div>
          </template>
          <template #cell(backup)="data">
            <div class="form-check form-switch">
              <div>
                <span v-if="data.value === true">
                  Oui
                  <feather-icon v-if="data.value === true" icon="CheckIcon" class="isBackup" />
                </span>
                <span v-else>Non</span>
              </div>
            </div>
          </template>
          <template #cell(roles)="data">
            <span v-if="data.item.roles && data.item.roles.length > 0 && data.item.roles[0]">
              {{ data.item.roles[0].split('.')[1] }}
            </span>
            <span v-else>-</span>
          </template>
          <template #cell(telephone)="data">
            <div v-if="data.item.telephone">
              <span>{{ data.item.telephone }}</span>
              <feather-icon v-if="!data.item.phoneNumberConfirmed" icon="XIcon" class="checkCircle" />
            </div>
          </template>
          <template #cell(email)="data">
            <div v-if="data.item.email">
              <span>{{ data.item.email }}</span>
              <feather-icon v-if="!data.item.emailConfirmed" icon="XIcon" class="checkCircle" />
            </div>
          </template>
          <template #cell(actions)="data">
            <div style="display: flex; gap: 8px;">
              <b-button v-if="!data.item.emailConfirmed" variant="info"
                        :title="resendingUserId === data.item.id ? 'Envoi en cours' : 'Renvoyer l\'email d\'activation'"
                        :disabled="resendingUserId === data.item.id" @click="resendEmailConfirmation(data.item)">
                <feather-icon icon="MailIcon" />
              </b-button>
              <b-button title="Modifier" @click="saveUserData(data.item)">
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button title="Réinitialiser le mot de passe" class="btn btn-warning"
                        @click="resetUserPassword(data.item)">
                <feather-icon icon="KeyIcon" />
              </b-button>
              <b-button v-if="data.item.roles && data.item.roles.length > 0 && data.item.roles[0] && data.item.roles[0].includes('Ecoutant')" title="Supprimer" class="btn btn-danger"
                        @click="openModalDeleteUser(data.item)">
                <feather-icon icon="DeleteIcon" />
              </b-button>
            </div>

          </template>
        </b-table>
      </div>
      <div v-else>
        <userForm :user-data="userData" :email="userData.email" :phone="userData.telephone" :mode="triggeredButton"
                  @submit="onFormSubmit" />
      </div>
    </b-card>
    <span v-if="displayTable" class="pagination-panel">
      <b-form-select v-model="perPage" class="pagination-panel__select" :options="displayResult" />
      <b-pagination v-model="currentPage" :total-rows="filteredUsers.length" :per-page="perPage"
                    aria-controls="my-table" />
      <p class="displaynbResult">Affichage ligne {{ perPage * currentPage }} sur {{ filteredUsers.length }}</p>
    </span>
    <b-modal ref="modalDeleteUser" hide-header hide-footer title="Supprimer l'utilisateur">
      <h2 class="text-primary text-center mb-2">
        Suppression d'un utilisateur
      </h2>
      <p class="text-center">
        Voulez-vous vraiment supprimer l'utilisateur {{ userData.prenom }} {{ userData.nom }} ?
      </p>

      <div class="d-flex justify-content-end">
        <b-button variant="danger" class="mr-2" @click="cancelDeleteUser()">
          Annuler
        </b-button>
        <b-button variant="primary" @click="deleteUser()">
          Valider
        </b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import store from '@/store' // eslint-disable-line
import { ref, computed } from '@vue/composition-api'
import {
  BCard,
  BTable,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BButton,
  BPagination,
  BFormSelect,
} from 'bootstrap-vue'
import SearchMatcher from '@/utils/SearchMatcher'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import userForm from './UserForm.vue'

export default {
  components: {
    BCard,
    BInputGroup,
    BFormInput,
    BInputGroupPrepend,
    BFormSelect,
    BTable,
    BButton,
    userForm,
    BPagination,
  },
  setup() {
    const displayTable = ref(true)
    const userData = ref({ nom: 'test' })
    const triggeredButton = ref('')
    const currentPage = ref(1)
    const resendingUserId = ref(null)
    const perPage = 5
    const displayResult = [
      5,
      10,
      15,
      20,
    ]

    const users = ref(computed(() => store.getters['users/users'].map(obj => {
      const status = obj.profile.isActive
      const backup = obj.profile.isBackup
      const message = obj.profile.canSendMessage ?? false
      const departement = obj.profile.department
      const roles = obj.roles && obj.roles.length > 0 ? obj.roles : []
      const {
        id,
        lastName: nom,
        firstName: prenom,
        phoneNumber: telephone,
        userName: identifiant,
        actions,
        ...rest
      } = obj

      return {
        id,
        nom,
        prenom,
        departement,
        status,
        backup,
        message,
        roles,
        identifiant,
        telephone,
        actions,
        ...rest,
      }
    })))
    if (users.value.length === 0) { store.dispatch('users/fetchUsers') }
    // Search
    const searchQuery = ref('')
    const searchMatcher = computed(() => new SearchMatcher(searchQuery.value))
    const filteredUsers = computed(() => users.value.filter(y => searchMatcher.value.match(
      y.email,
      y.prenom,
      y.nom,
    )))

    function onFormSubmit(data) {
      displayTable.value = data
    }

    function addUser() {
      displayTable.value = false
      triggeredButton.value = 'ajouter'
      userData.value = { status: true }
    }
    function backToTable() {
      displayTable.value = true
    }

    function saveUserData(data) {
      userData.value = data
      triggeredButton.value = 'modifier'
      displayTable.value = false
    }

    function resetUserPassword(data) {
      userData.value = data
      triggeredButton.value = 'reset'
      displayTable.value = false
    }

    const fields = [
      { key: 'nom', sortable: true },
      { key: 'prenom', sortable: true },
      { key: 'identifiant', sortable: true },
      { key: 'roles', sortable: true },
      { key: 'departement', sortable: true },
      { key: 'status', sortable: true },
      { key: 'message', label: 'Messages', sortable: true },
      { key: 'backup', sortable: true },
      { key: 'telephone', sortable: true },
      { key: 'email', sortable: true },
      { key: 'actions', sortable: true },
    ]

    const toast = useToast()
    const displayToast = (title, icon, mode) => {
      toast({
        component: ToastificationContent,
        props: {
          title,
          position: 'bottom-right',
          icon,
          variant: mode,
        },
      })
    }

    return {
      displayTable,
      searchQuery,
      searchMatcher,
      filteredUsers,
      displayResult,
      triggeredButton,
      saveUserData,
      userData,
      onFormSubmit,
      backToTable,
      users,
      addUser,
      fields,
      perPage,
      currentPage,
      resendingUserId,
      resetUserPassword,
      displayToast,
      toast,
    }
  },
  methods: {
    async resendEmailConfirmation(data) {
      if (this.resendingUserId) {
        return
      }

      this.resendingUserId = data.id
      try {
        await store.dispatch('users/resendEmailConfirmation', data.id)
        this.displayToast('Email d\'activation renvoyé', 'CheckIcon', 'success')
      } catch (error) {
        this.displayToast('Impossible de renvoyer l\'email d\'activation', 'XCircleIcon', 'danger')
      } finally {
        this.resendingUserId = null
      }
    },
    openModalDeleteUser(data) {
      this.userData = data
      this.$refs.modalDeleteUser.show()
    },

    cancelDeleteUser() {
      this.$refs.modalDeleteUser.hide()
    },

    async deleteUser() {
      await store.dispatch('users/deleteUser', this.userData.id).then(() => {
        this.displayToast('Utilisateur supprimé', 'CheckIcon', 'success')
        this.$emit('submit', true)
      })
        .catch(() => {
          // Gestion générique pour d'autres erreurs
          this.displayToast(
            'Impossible de supprimer cet utilisateur',
            'XCircleIcon',
            'danger',
          )
        })
      this.$refs.modalDeleteUser.hide()
    },
  },
}
</script>

<style lang="scss" scoped>
.pagination {
  margin-top: 15px;
}

.pagination-panel {
  width: auto;
  display: flex;
  align-items: center;

  &__select {
    width: auto;
  }
}

.displaynbResult {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}

.checkCircle {
  margin-left: 15px;
  color: red;
}

.isBackup {
  color: forestgreen;
}
</style>
